import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { DevolutionStoreAction } from '../../store/pix/actions/devolution.store.action';
import { TransactionStoreAction } from '../../store/pix/actions/transaction.store.action';

@NgModule({
  imports: [
    CommonModule,
  ],
  providers: [
    DevolutionStoreAction,
    TransactionStoreAction,
  ],
  exports: []
})
export class StateManagerPixModule {}
